import "./bottomNav.css"

const bottomNav = () => {
    return (
        <div className="b-nav contact" id="contact">
            <div className="b-icons">
                <a class="fab fa-linkedin fa-2x" href="https://www.linkedin.com/in/srijan-bhardwaj/" target="_blank" rel="noreferrer"></a>
                <a class="fab fa-github fa-2x" href="https://github.com/Srijan0101" target="_blank" rel="noreferrer"></a>
                <a class="fab fa-twitter fa-2x" href="https://twitter.com/SrijanBhardwaj1" target="_blank" rel="noreferrer"></a>
            </div>
            <div className="b-text">Created by Srijan Bhardwaj | srijan547@gmail.com </div>

            
        </div>
    )
}

export default bottomNav
